import React from 'react';

import {
  EmployerStaffsListDocument,
  useCheckDeletionEmployerStaffQuery,
  useDeleteEmployerStaffMutation,
} from 'src/api';
import { useNotification } from 'src/hooks/app';
import { DeleteConfirmationModal } from 'src/modals/common';
import { ModalV2Props } from 'src/types/modalV2';

type DeleteEmployerStaffConfirmationModalProps = {
  employerStaffId: string;
};

export const DeleteEmployerStaffConfirmationModal: React.FC<
  ModalV2Props<DeleteEmployerStaffConfirmationModalProps>
> = ({ id, employerStaffId }) => {
  const { createApolloContext } = useNotification();

  const { data, loading } = useCheckDeletionEmployerStaffQuery({
    variables: { employerStaffId },
    fetchPolicy: 'network-only',
  });

  const [deleteEmployerStaff, { loading: deleteLoading }] = useDeleteEmployerStaffMutation({
    refetchQueries: [EmployerStaffsListDocument],
    context: createApolloContext({ successMessage: 'Successfully deleted' }),
  });

  const handleConfirm = React.useCallback(
    () => deleteEmployerStaff({ variables: { employerStaffId } }),
    [deleteEmployerStaff, employerStaffId],
  );

  return (
    <DeleteConfirmationModal
      id={id}
      entityName="Employer staff"
      description="You want to delete this staff member?"
      check={data?.checkDeletionEmployerStaff}
      loading={loading}
      deleteLoading={deleteLoading}
      onConfirm={handleConfirm}
    />
  );
};
